import { render, staticRenderFns } from "./conf.vue?vue&type=template&id=1027f246&scoped=true&"
import script from "./conf.vue?vue&type=script&lang=js&"
export * from "./conf.vue?vue&type=script&lang=js&"
import style0 from "./conf.vue?vue&type=style&index=0&id=1027f246&prod&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1027f246",
  null
  
)

export default component.exports